import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const MenuWrapper = styled.div`
  width: 100%;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  padding: 3px 0;
  line-height: 0;
  display: table;

  & ul {
    width: 920px;
    display: table-cell;
    vertical-align: middle;
  }

  & li {
    width: 184px;
    float: left;
    padding: 0 3px;
    border-left: #dddddd dashed 1px;
    & :last-child {
      border-right: #dddddd dashed 1px;
    }
    & a {
      width: 178px;
      height: 31px;
      position: relative;
      display: block;
      & .title {
        padding-top: 12px;
        font-size: 1em;
        font-weight: 700;
        color: #004a88;
      }
      & .sub-title {
        padding-top: 1.4em;
        font-size: 0.6em;
        font-weight: 700;
        color: #858585;
      }
      & :hover {
        background-color: #005daa;
        border-radius: 5px;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
      }
    }
    & .header-menu {
      clear: left;
      display: flex;
      flex-direction: column;
      text-decoration: none;
    }
  }
  & li a:hover .title,
  & li .active .title {
    color: #ffffff;
  }

  & li a:hover .sub-title,
  & li .active .sub-title {
    color: #ffffff;
  }

  & .active {
    background-color: #bfcde3;
    border-radius: 5px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    width: 178px;
    height: 31px;
    position: relative;
    display: block;
  }

  & .active .title {
    padding-top: 12px;
    font-size: 1em;
    font-weight: 700;
    color: #004a88;
  }

  & .active .sub-title {
    padding-top: 1.4em;
    font-size: 0.6em;
    font-weight: 700;
    color: #858585;
  }

  & li a img,
  & .active img {
    position: absolute;
    left: 50%;
    margin-left: -40px;
    top: 50%;
    margin-top: -12px;
  }
`;
const HeaderFunctions = styled.div`
  width: 280px;
  padding: 0 10px;
  display: table-cell;
  vertical-align: middle;

  & .english {
    width: 86px;
    height: 24px;
    background-color: #005daa;
    border-radius: 5px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    display: inline-block;
  }

  & .english:hover {
    background-color: #004a88;
  }

  & .english a {
    text-decoration: none;
    color: #fff;
    line-height: 24px;
    font-size: 0.9em;
  }
`;

const FontChanger = styled.div`
	width: 160px;
	height: 24px;
	float: right;
	position: relative;
	background-color: #005daa;
	border-radius: 5px;
	-moz-border-radius: 5px;
	-webkit-border-radius: 5px;
	float: right;
	display: flex;
	flex-direction: row;
	padding: 2px;
	& span {
		color: #ffffff;
		width: 80px;
		height: 100%;
		line-height: 1.8em;
		font-size: 0.8em;
	}

	& button {
		width: 40px;
		height: 20px;
		color: #004379;
		font-size: 0.8em;
		line-height: 1.4em;
		font-weight: 700;
	}
`;

interface IProps {
  onGoStandard?: () => void,
  onGoLarger?: () => void,
}

const Menu: React.FC<IProps> = ({ onGoLarger, onGoStandard }) => {
  return (
    <MenuWrapper>
      <div className="inbox">
        {/* メニュー */}
        <ul className="clearfix">
          <li>
            <Link to="/" activeClassName="active" className="header-menu">
              <div className="title">ホーム</div>
              <div className="sub-title">Home</div>
            </Link>
          </li>
          <li>
            <Link to="/club" activeClassName="active" className="header-menu">
              <div className="title">クラブ概要</div>
              <div className="sub-title">Club</div>
            </Link>
          </li>
          <li>
            <Link to="/volunteer" activeClassName="active" className="header-menu">
              <div className="title">奉仕活動</div>
              <div className="sub-title">Volunteer</div>
            </Link>
          </li>
          <li>
            <Link to="/members" activeClassName="active" className="header-menu">
              <div className="title">会員募集</div>
              <div className="sub-title">Member</div>
            </Link>
          </li>
          <li>
            <a
              href="mailto:jimukyoku@tokyochuo-rotary.org?subject=お問い合わせ"
              className="header-menu"
            >
              <div className="title">お問い合わせ</div>
              <div className="sub-title">Contact</div>
            </a>
          </li>
        </ul>
        {/* メニュー END */}
        {/* バナー */}
        <HeaderFunctions>
          {/* English */}
          <div className="english">
            <a
              href="/translate/en.html"
              onClick={() => window.open('translate/en.html', '', 'width=850,height=600,scrollbars=yes')}
            >
              English
            </a>
          </div>
          {/* English */}

          {/* 文字サイズ */}
          <FontChanger>
            <span>文字サイズ</span>
            <button onClick={onGoStandard}>標準</button>
            <button onClick={onGoLarger}>大</button>
          </FontChanger>
          {/* 文字サイズ　END */}

        </HeaderFunctions>
        {/* バナー END */}
      </div>
    </MenuWrapper>
  );
};

export default Menu;
